import { FormSectionHeader } from '../../../../shared/form-section-header';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export default function FormSkeleton() {
  return (
    <Stack spacing={4} width="100%">
      <Stack spacing={1} sx={{ flex: 1, pr: 3 }}>
        <Stack spacing={0.9}>
          <Stack spacing={2}>
            <FormSectionHeader>Basic Information</FormSectionHeader>
            <Stack spacing={0.9}>
              {/* Policy Name */}
              <Skeleton variant="rounded" width={400} height={40} />
              <Box height={12}> </Box>
            </Stack>
          </Stack>
          {/* Trigger Type + Act Immediately */}
          <Stack direction="row" spacing={2} alignItems="center">
            <Skeleton variant="rounded" width={400} height={40} />
            <Box height={12}> </Box>
          </Stack>

          <Stack spacing={0} sx={{ pt: 3, pb: 1 }}>
            {/* Checkbox and Label Skeleton */}
            <Stack
              direction="row"
              alignItems="center"
              spacing={1.5}
              sx={{ py: 1.5 }}
            >
              {/* Checkbox placeholder (MUI Checkboxes are typically 24x24) */}
              <Skeleton variant="rounded" width={24} height={24} />

              {/* Label placeholder */}
              <Skeleton variant="rounded" width={120} height={24} />
            </Stack>
            <Stack pl={4.5}>
              <Skeleton variant="rounded" width={730} height={15} />
            </Stack>
          </Stack>

          {/* Select Org */}
          <Stack sx={{ pb: 1.5 }}>
            <Box sx={{ mt: 3, mb: 1 }}>
              <Skeleton variant="rounded" width={400} height={20} />
            </Box>
            <Stack flexDirection="row" gap={1}>
              <Skeleton variant="rounded" width={400} height={40} />
            </Stack>
            <Box height={12}> </Box>
          </Stack>
        </Stack>

        <Divider sx={{ width: '100%' }} />
        {/* More Configuration Toggle */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-start', py: 2 }}>
          <Skeleton variant="rounded" width={200} height={20} />
        </Box>
      </Stack>
    </Stack>
  );
}
